import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import Flex from './flex.mjs';

function horizontalGap(space, selector) {
  return {
    [`& > ${selector} ~ ${selector}`]: {
      marginLeft: `${space}px`
    }
  };
}
function verticalGap(space, selector) {
  return {
    [`& > ${selector} ~ ${selector}`]: {
      marginTop: `${space}px`
    }
  };
}
function gap({
  direction,
  space: rawSpace = "small",
  selector = '*:not([style*="display: none"])'
}) {
  const getSpace = (space) => {
    if (typeof space === "number") {
      return space;
    }
    return {
      small: 8,
      middle: 16,
      large: 24
    }[space];
  };
  if (direction === "horizontal") {
    return horizontalGap(getSpace(rawSpace), selector);
  }
  return verticalGap(getSpace(rawSpace), selector);
}
const StackInternal = forwardRef(
  ({
    direction = "horizontal",
    space = "small",
    selector,
    align,
    justify,
    css: externalCss,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx(
      Flex,
      {
        ref,
        css: {
          ...gap({ space, direction, selector }),
          ...externalCss
        },
        direction: direction === "vertical" ? "column" : "row",
        align,
        justify,
        ...props
      }
    );
  }
);
const StackHorizontal = forwardRef(({ direction = "horizontal", align = "center", ...props }, ref) => /* @__PURE__ */ jsx(Stack, { ref, direction, align, ...props }));
const StackVertical = forwardRef(({ direction = "vertical", ...props }, ref) => /* @__PURE__ */ jsx(Stack, { ref, direction, ...props }));
const Stack = StackInternal;
Stack.Horizontal = StackHorizontal;
Stack.Vertical = StackVertical;

export { Stack as default, gap };
//# sourceMappingURL=stack.mjs.map
